<template>
    <connection-settings-popup
        :resources="{
            deletePromptTitle: resource('JourneyBuilder_FilterExclusionSettings_Delete_Title'),
            deletePromptBody: resource('JourneyBuilder_FilterExclusionSettings_Delete_Body')
        }"
        :comment-id="commentId"

        @save="save()"
        @delete="deleteCheckpoint()"
        @hidden="$emit('hidden')"
    >
        <template #title>
            <div class="w-100">
                <h3 class="d-inline-block mr-1">{{resource('JourneyBuilder_FilterExclusionSettings_Title')}}</h3>
                <help-popover :content="resource('JourneyBuilder_FilterExclusionSettings_Explanation')" />
            </div>
        </template>
        
        <template #body>
            <div class="row form-group">
                <div class="col-12 text-center">
                    <button class="btn btn-outline-primary" @click="openFilterSettings()"><i class="fas fa-pencil-alt mr-1" /> {{resource('JourneyBuilder_FilterExclusionSettings_Button_EditFilters')}}</button>
                </div>
            </div>

            <template v-for="filterGroup in filters">
                <div class="row form-group no-gutters filter-group" :key="filterGroup.id">
                    <div class="col-2">
                        <toggle-button class="mt-3" v-if="enableTogglingFilterExclusionGroups"
                                       :value="!isFilterExcluded(filterGroup.id)"
                                       @input="toggleFilterExclusion(filterGroup.id, !$event)"
                        />
                    </div>

                    <div class="col-10">
                        <brick-filter-condition 
                            v-for="filter in filterGroup.children" 
                            :field="filter.field"
                            :operator="filter.operator"
                            :value="filter.value" 
                        />
                    </div>
                </div>
            </template>
        </template>
    </connection-settings-popup>
</template>

<script>
import _ from 'lodash';

import {filterExclusionCheckpoint} from "@modules/JourneyBuilder/Bricks/Checkpoints";
import {mapMutations} from 'vuex';
import {FLAGS} from "@modules/JourneyBuilder/constants";
import conditionExpansion from './condition-expansion';

import resourceMixin from "@core/Util/Mixins/resources";
import injectJourneyMixin from '@modules/JourneyBuilder/Mixins/inject-journey';
import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';

import { NewComment } from '@modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Comments';
import BrickFilterCondition from "./BrickFilterCondition";
import HelpPopover from "@modules/JourneyBuilder/Components/Elements/HelpPopover";
import { ToggleButton } from 'vue-js-toggle-button';
import ConnectionSettingsPopup from '../ConnectionSettingsPopup';

export default {
    name: "BrickFilterExclusionSettings",
    components: {
        BrickFilterCondition,
        HelpPopover,
        ToggleButton,
        NewComment,
        ConnectionSettingsPopup
    },
    
    mixins: [resourceMixin, injectJourneyMixin, permissionsMixin],
    
    props: {
        connection: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        }
    },
    
    data(){
        return {
            model: undefined,
            enableTogglingFilterExclusionGroups: FLAGS.enableTogglingFilterExclusionGroups
        }
    },

    computed: {
        filters(){
            return conditionExpansion.inflateGenericFilters(this.journey.config.filters);
        },

        commentId() {
            return "connection:" + this.connection.id + ":" + filterExclusionCheckpoint.name;
        },
    },

    watch: {
        filters(newFilters){
            //Close self - no more filters to be edited, checkpoint is removed
            if(newFilters.length === 0){
                this.$emit('hidden');
                return;
            }

            //Process backwards to prevent skipping items on removal
            for(let filterIndex = this.model.excludedFilters.length - 1; filterIndex >= 0; filterIndex--){
                const filterId = this.model.excludedFilters[filterIndex];
                const isRemoved = !newFilters.some(filter => filter.id === filterId);
                
                if(isRemoved){
                    this.model.excludedFilters.splice(filterIndex, 1);
                }
            }
        }
    },

    created() {
        const model = _.cloneDeep(
            filterExclusionCheckpoint.readForConnection(this.connection)
        ) || {};
        
        //Update our model prior to setting our data field to ensure reactivity for all properties
        if(!model.excludedFilters){
            model.excludedFilters = [];
        }
        
        this.model = model;
    },
    
    methods: {
        ...mapMutations('journeyBuilder/composer', ['toggleJourneyFiltersEditor']),
        
        openFilterSettings(){
            this.toggleJourneyFiltersEditor(true);
        },
        
        isFilterExcluded(filterId){
            return this.model.excludedFilters.includes(filterId);
        },
        
        toggleFilterExclusion(filterId, isExcluded){
            filterExclusionCheckpoint.toggleFilterExclusion(this.model, filterId, isExcluded);
        },

        deleteCheckpoint(){
            this.$emit('delete-connection-checkpoint', { connection: this.connection, checkpoint: filterExclusionCheckpoint.name });
        },
        
        save(){
            //Configuration is not to be altered by our editor for the time being
            this.$emit('hidden');
            
            // this.$emit("save", {
            //     [filterExclusionCheckpoint.name]: this.model
            // });
        },
    }
}
</script>

<style scoped>
    .filter-group {
        background-color: #E3E3E3;
    }
</style>